// @core/api/endpoints/workflow/get_pending_decision.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PendingDecisionResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get pending decision
 * Returns one outstanding decision with the context an approver needs.
 */
export async function GetPendingDecision(
  decision_id: string,
  options?: RequestOptions
): Promise<PendingDecisionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/decisions/:decision_id`;
  requestPath = requestPath.replace(':decision_id', encodeURIComponent(decision_id));
  const requestOptions = options;
  return client.get<PendingDecisionResponse>(requestPath, { ...requestOptions });
}
